"use client";

import { useMemo } from "react";
import { StatCard } from "@/components/StatCard";
import { BalanceChart } from "@/components/BalanceChart";
import { TransactionTable } from "@/components/TransactionTable";
import { generateMockTransactions, generateMockBalanceData } from "@/data/mockData";
import { Wallet, TrendingUp, TrendingDown } from "lucide-react";

const Index = () => {
  const transactions = useMemo(() => generateMockTransactions(), []);
  const balanceData = useMemo(
    () => generateMockBalanceData(transactions),
    [transactions]
  );

  const currentBalance = balanceData[balanceData.length - 1]?.balance || 0;
  const totalIncome = transactions
    .filter((t) => t.type === "income")
    .reduce((sum, t) => sum + t.amount, 0);
  const totalExpense = transactions
    .filter((t) => t.type === "expense")
    .reduce((sum, t) => sum + t.amount, 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 py-8 px-4">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Header */}
        <div className="space-y-2">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">
            Banking Dashboard
          </h1>
          <p className="text-slate-600 dark:text-slate-400">
            Your account overview and recent transactions
          </p>
        </div>

        {/* Stat Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <StatCard
            title="Current Balance"
            value={currentBalance}
            icon={Wallet}
            color="cyan"
          />
          <StatCard
            title="Total Income"
            value={totalIncome}
            icon={TrendingUp}
            color="green"
          />
          <StatCard
            title="Total Expenses"
            value={totalExpense}
            icon={TrendingDown}
            color="red"
          />
        </div>

        {/* Chart */}
        <BalanceChart data={balanceData} />

        {/* Transactions */}
        <TransactionTable transactions={transactions} />
      </div>
    </div>
  );
};

export default Index;